<template>
  <div class="authority_wrap">
    <BreadCrumb crumb="运营日志"></BreadCrumb>
    <div class="top_bar">
      <el-row>
        <el-col :span="8">
          <el-input placeholder="请输入搜索内容: 账号/手机号/状态" v-model="keyword" class="input-with-select" size="small">
            <el-button slot="append" icon="el-icon-search" @click="fnGetData(1)"></el-button>
          </el-input>
        </el-col>

          <el-col :span="7" :offset='1'>
            <el-date-picker style='height: 32px'
              v-model="value"
              type="datetimerange"
              range-separator="至"
              size="small"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-col>

          <el-col :span="5" >
            <div class="find">查询</div>
          </el-col>
      </el-row>
    </div>
    <OperationLogTable :authors="aAuthorList" @fnResetTable="fnGetData(1)"></OperationLogTable>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-count="pages"
      :current-page="page"
      style="text-align:center;margin-top:10px"
      @current-change="fnGetPage"
      >
    </el-pagination>
  </div>
</template>

<script>
import BreadCrumb from '@/components/widget/BreadCrumb'
import AddAuthor from '@/components/widget/AddAuthor'
import OperationLogTable from '@/components/widget/OperationLogTable'

import cons from '@/components/constant'

export default {
  name: 'Authority',
  data () {
    return {
      keyword: '',
      value: '',
      page:1,
      pages:8,
      pagesize:10,
      aAuthorList:[]
    }
  },
  components:{
    BreadCrumb,
    AddAuthor,
    OperationLogTable
  },
  mounted(){
    this.fnGetData(1);
  },
  methods:{
    fnGetData:function(num){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/operationlogs', {
          headers: {
            'Authorization': 'Bearer ' + token
          },
          responseType: 'json',
          params:{
            page:num,
            order_by: 'id',
            keyword: this.keyword,
            per_page:this.pagesize
          }
      })
      .then(dat=>{
          this.aAuthorList = dat.data.data.operationlogs;
          this.page = num;
          this.pages = dat.data.data.total_count;
      }).catch(err=>{
         console.log(err);
      });
    },
    fnGetPage:function(dat){
      this.page = dat;
      this.fnGetData(this.page);
    }
  }
}
</script>

<style scoped>
.top_bar{
    width:95.2%;
    overflow:hidden;
    margin:10px auto;
  }

  .batch_operation, .export_data, .find {
  width: 92px;
  height: 38px;
  color: #fff;
  font: 12px/38px 'simsun';
  text-align: center;
  background-color: #FB5557;
  border-radius: 3px;
  cursor: pointer;
}
.find {
  width: 80px;
  height: 32px;
  line-height: 32px;
  margin-left: 140px;
}
.batch_operation:hover, .export_data:hover, .find:hover {
  background-color: rgb(252, 119, 121);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/OperationLog.vue